import { useState } from "react"
import isEmpty from "lodash.isempty"

import { Form, Field } from "web/components"

import MobileHeader from "./MobileHeader"
import { DropDownActionButtons } from "../Buttons"
import OperatorRadio from "../OperatorRadio"
import { getOperators, conditionFromFormValue } from "./helpers"

const defaultMinHeight = "md:min-h-none min-h-full"

export function getDefaultValues(condition) {
  const operator = condition.operator
    ? getOperators("Distance").find((op) => op.value === condition.operator)
    : { value: "less_than", label: "less than" }

  const value = condition.value || {}
  return {
    match_blank: condition.match_blank
      ? { value: condition.match_blank }
      : { value: false },
    operator,
    value,
  }
}

export default function EditSpacialTypeDistanceConditionDropDown({
  condition,
  onCancel = () => {},
  onChange = () => {},
  onClear = () => {},
}) {
  const [formValue, setFormValue] = useState(getDefaultValues(condition))

  const minHeight = defaultMinHeight

  const formFields = [
    {
      name: "value",
      key: "value",
      kind: "Distance",
      label: null,
      is_attribute: false,
      expression: null,
      show_expression: null,
      required: null,
      multiple_values: false,
    },
    {
      key: "operator",
      name: "operator",
      kind: "Lookup",
      lookup_values: getOperators("Distance"),
      label: "Comparison",
      format: "Radio",
    },
  ]
  return (
    <div
      className={`flex max-w-full flex-col p-6 md:min-w-sm md:max-w-md ${minHeight}`}
    >
      <MobileHeader field={{ label: "Distance" }} onCancel={onCancel} />
      <Form
        value={formValue}
        onChange={(newValue) => {
          setFormValue(newValue)
        }}
        onSubmit={() => {
          onChange(conditionFromFormValue(null, formValue))
        }}
        fields={formFields}
        render={(form) => (
          <>
            <div className="flex flex-grow flex-col space-y-6 md:flex-row md:justify-between md:space-y-0">
              <div>
                <Field
                  fieldKey="operator"
                  showValueLabel={false}
                  flexDirection="col"
                  Control={OperatorRadio}
                />
              </div>
              <div className="max-h-96 w-52 overflow-y-auto px-0.5">
                <Field
                  fieldKey="value"
                  autoFocus={isEmpty(formValue.value)}
                  allowQuickAdd={false}
                  onChange={(newValue) =>
                    setFormValue((formValue) => {
                      return {
                        ...formValue,
                        value: newValue,
                      }
                    })
                  }
                />
              </div>
            </div>
            <div className="justify-end pt-4">
              <div className="flex items-center">
                <DropDownActionButtons
                  handleClear={onClear}
                  handleAdd={form.submit}
                />
              </div>
            </div>
          </>
        )}
      ></Form>
    </div>
  )
}
